import { Component } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ExpenseService } from '../../../../../core/services/expense.service';
import { BudgetService } from '../../../../../core/services/budget.service';
import { AcademicYearService } from '../../../../../core/services/academic-year.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-expense',
  templateUrl: './expense.component.html',
  imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule],
  styleUrls: ['./expense.component.css']
})
export class ExpenseComponent {
  buttonsPermission: any;
  search_text = '';
  data: any[] = [];
  budgets: any[] = [];
  ays: any[] = [];
  summary: any = null;
  selected_data: any;
  loading = false;

  form: any = this.emptyForm();

  readonly CATEGORIES = ['Salaires', 'Fournitures', 'Maintenance', 'Transport', 'Loyer', 'Électricité & Eau', 'Communication', 'Restauration', 'Divers'];
  readonly PAYMENT_METHODS = ['Espèces', 'Virement', 'Mobile Money', 'Chèque'];

  pg = { pageSize: 10, p: 0, total: 0 };

  constructor(
    private expenseService: ExpenseService,
    private budgetService: BudgetService,
    private ayService: AcademicYearService,
    private toastrService: ToastrService,
    config: NgbModalConfig,
    private modalService: NgbModal
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.buttonsPermission = { show: false, add: true, edit: true, delete: true, status: true };
    this.getAll();
    this.getSummary();
    this.getBudgets();
    this.getAys();
  }

  emptyForm() {
    return { label: '', category: '', amount: 0, expense_date: new Date().toISOString().substring(0, 10), payment_method: 'Espèces', beneficiary: '', budget_id: null, academic_year_id: null, description: '' };
  }

  getAll() {
    this.loading = true;
    this.expenseService.getAll().subscribe((res: any) => {
      this.loading = false;
      this.data = res.data ?? [];
      this.pg.total = this.data.length;
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Gestion des dépenses', err); });
  }

  getSummary() {
    this.expenseService.summary().subscribe((res: any) => { this.summary = res.data; }, () => {});
  }

  getBudgets() {
    this.budgetService.getAll().subscribe((res: any) => {
      this.budgets = (res.data ?? []).filter((b: any) => b.category === 'depense');
    }, () => {});
  }

  getAys() {
    this.ayService.getAll().subscribe((res: any) => { this.ays = res.data ?? []; }, () => {});
  }

  store(value: any) {
    this.loading = true;
    this.expenseService.store(value).subscribe((res: any) => {
      this.loading = false;
      this.toastrService.success(res.message);
      this.modalService.dismissAll();
      this.form = this.emptyForm();
      this.refresh();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Gestion des dépenses', err); });
  }

  update(value: any) {
    this.loading = true;
    this.expenseService.update(this.selected_data.id, value).subscribe((res: any) => {
      this.loading = false;
      this.toastrService.success(res.message);
      this.modalService.dismissAll();
      this.refresh();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Gestion des dépenses', err); });
  }

  delete() {
    if (!this.verifyChecked()) return;
    const confirmed = AppSweetAlert.confirmBox('info', 'Suppression', 'Voulez-vous vraiment supprimer cette dépense ?');
    confirmed.then((result: any) => {
      if (result.isConfirmed) {
        this.expenseService.delete(this.selected_data.id).subscribe((res: any) => {
          this.toastrService.success(res.message);
          this.refresh();
        }, (err: any) => AppErrorShow.showError('Gestion des dépenses', err));
      }
    });
  }

  refresh() { this.getAll(); this.getSummary(); this.getBudgets(); }

  checked(el?: any) { this.selected_data = el; }

  verifyChecked() {
    if (this.selected_data == null) { this.toastrService.warning('Aucun élément sélectionné'); return false; }
    return true;
  }

  add(content: any) {
    this.form = this.emptyForm();
    this.modalService.open(content, { size: 'lg' });
  }

  edit(content: any) {
    if (!this.verifyChecked()) return;
    this.form = { ...this.selected_data };
    this.modalService.open(content, { size: 'lg' });
  }

  dismiss() { this.modalService.dismissAll(); }

  getPage(event: any) { this.pg.p = event; }

  statusLabel(s: number) { return s == 1 ? 'Validée' : (s == 2 ? 'En attente' : 'Annulée'); }
  statusClass(s: number) { return s == 1 ? 'bg-green-100 text-green-700' : (s == 2 ? 'bg-orange-100 text-orange-700' : 'bg-gray-100 text-gray-500'); }
}
